<template>
    <div v-bind:id="`accept-` + job.job_id" class="margin-bottom-2">
        <div class="job-link component position-relative">
            <!-- If it's a candidate -->
            <template v-if="!company">
                <div class="card" :class="job.is_declined ? 'declined' : ''">
                    <div class="card-top-row">
                        <div v-if="parseInt(job.is_declined)" class="declined">Afgewezen</div>
                        <div v-if="parseInt(job.percentage)" class="match_percentage">{{ parseInt(job.percentage) }}% match</div>
                        <div v-if="parseInt(job.is_interested)" class="bell"><svg-icon icon="notification_bell" /></div>
                        <div v-if="accept" class="icon-wrapper float-left mt-2"><svg-icon icon="thumbs_up" /></div>
                    </div>

                    <div class="card-body" :class="accept || highlight || (job.applicants_count && user.type === 2) ? 'sd-highlighted' : ''">
                        <div class="card-body-inner" :class="[arrow ? 'w-arrow' : 'no-arrow']">
                            <div class="jobCardSpecs-image">
                                <img v-if="job.company_avatar" :src="job.company_avatar" class="img-item"  alt=""/>
                                <svg-icon v-else icon="healthcare" class="img-item"/>
                            </div>

                            <div class="jobCardSpecs">
                                <router-link :to="{ name: 'job-healthcare-view', params: params}">
                                    <ul>
                                        <template>
                                            <li>
                                                <svg-icon icon="calendar"></svg-icon>
                                                <b>Start: {{ getFirstWorkingDate() }}</b>
                                            </li>
                                            <li>
                                                <svg-icon icon="calendar"></svg-icon>
                                                <b>Eind: {{ getLastWorkingDate() }}</b>
                                            </li>

                                            <li><svg-icon icon="first_aid_kit"></svg-icon>{{ job.groups[0].answer }} - {{ job.qualifications[0].answer }}</li>

                                            <li v-if="job.city">
                                                <svg-icon icon="marker"></svg-icon>
                                                <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                                                <span v-else>{{ job.city }}</span>
                                            </li>

                                            <li class="shift-items">
                                                <template v-for="shift in this.shifts_arr">
                                                    <span class="shift-item">{{ shift }}</span>
                                                </template>
                                            </li>
                                        </template>
                                    </ul>
                                </router-link>
                            </div>
                        </div>

                        <router-link
                            v-if="arrow"
                            :to="{ name: 'job-healthcare-view', params: params }"
                            class="arrow position-absolute d-block h-100"
                            v-ripple="'rgba(255, 255, 255, 0.35)'"
                        >
                            <span class="icon-wrapper position-absolute">
                                <svg-icon icon="chevron_e" />
                            </span>
                        </router-link>

                        <button
                            v-if="accept"
                            v-on:click.stop="onAccept(job.matched_applicant_id)"
                            type="button"
                            class="btn btn-light btn-block"
                        >
                            Accepteren
                        </button>
                    </div>
                </div>
            </template>

            <!-- If it's a company -->
            <template v-if="company">
                <div class="card">
                    <div class="card-top-row">
                        <div v-if="parseInt(job.is_interested)" class="bell">
                            <svg-icon icon="notification_bell" />
                        </div>
                    </div>

                    <div class="card-body" :class="accept || highlight || (job.applicants_count && user.type === 2) ? 'sd-highlighted' : ''">
                        <div class="card-body-inner" :class="[arrow ? 'w-arrow' : 'no-arrow', company ? 'company-card' : '']">
                            <div v-if="accept" class="icon-wrapper float-left mt-2">
                                <svg-icon icon="thumbs_up" />
                            </div>

                            <div class="jobCardSpecs-image">
                                <img v-if="job.company_avatar" :src="job.company_avatar" class="img-item"  alt=""/>
                                <svg-icon v-else icon="healthcare" class="img-item"/>
                            </div>

                            <div class="jobCardSpecs">
                                <router-link :to="{ name: 'job-healthcare-view', params: params}">
                                    <ul>
                                        <li>
                                            <svg-icon icon="calendar"></svg-icon>
                                            <b>Start: {{ getFirstWorkingDate() }}</b>
                                        </li>

                                        <li>
                                            <svg-icon icon="calendar"></svg-icon>
                                            <b>Eind: {{ getLastWorkingDate() }}</b>
                                        </li>

                                        <li><svg-icon icon="first_aid_kit"></svg-icon>{{ job.group[0] }} - {{ job.qualification[0] }}</li>

                                        <li v-if="job.city">
                                            <svg-icon icon="marker"></svg-icon>
                                            <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                                            <span v-else>{{ job.city }}</span>
                                        </li>

                                        <li class="shift-items">
                                            <template v-for="shift in this.shifts_arr">
                                                <span class="shift-item">{{ shift }}</span>
                                            </template>
                                        </li>

                                        <template v-if="!open">
                                            <li>
                                                <router-link
                                                    v-if="job.applicants_count"
                                                    :to="{ name: 'job-applicants', params: { id: parseInt(job.id) } }"
                                                    class="people-overview applicants"
                                                    v-ripple="'rgba(255, 255, 255, 0.35)'"
                                                >
                                                    <span v-for="index in job.applicants_count" :key="index" v-if="index <= 4" class="profile-circle">{{ index }}</span>
                                                    <span v-if="job.applicants_count > 4" class="profile-circle">+{{ job.applicants_count - 4 }}</span>
                                                </router-link>
                                            </li>

                                            <li>
                                                <router-link
                                                    v-if="job.matches_count"
                                                    :to="{ name: 'job-matches', params: { id: parseInt(job.id) } }"
                                                    class="people-overview recommendations"
                                                    v-ripple="'rgba(255, 255, 255, 0.35)'"
                                                >
                                                    <span v-for="index in job.matches_count" :key="index" v-if="index <= 4" class="profile-circle">{{ index }}</span>
                                                    <span v-if="job.matches_count > 4" class="profile-circle">+{{ job.matches_count - 4 }}</span>
                                                </router-link>
                                            </li>
                                        </template>
                                    </ul>
                                </router-link>
                            </div>
                        </div>

                        <router-link
                            v-if="arrow"
                            :to="{ name: 'job-healthcare-view', params: params }"
                            class="arrow position-absolute d-block h-100"
                            v-ripple="'rgba(255, 255, 255, 0.35)'"
                        >
                            <span class="icon-wrapper position-absolute">
                                <svg-icon icon="chevron_e" />
                            </span>
                        </router-link>

                        <button
                            v-if="accept"
                            v-on:click.stop="onAccept(job.matched_applicant_id)"
                            type="button"
                            class="btn btn-light btn-block"
                        >
                            Accepteren
                        </button>

                        <div class="control-bar">
                            <div class="control-bar-top">
                                <router-link
                                    v-if="job.applicants_count"
                                    :to="{ name: 'job-applicants', params: { id: parseInt(job.id) } }"
                                    class="sd-button btn btn-warning"
                                    v-ripple="'rgba(255, 255, 255, 0.35)'"
                                >
                                    Bekijk sollicitaties
                                </router-link>

                                <router-link
                                    v-if="job.matches_count"
                                    :to="{ name: 'job-matches', params: { id: parseInt(job.id) } }"
                                    class="sd-button btn btn-warning"
                                    v-ripple="'rgba(255, 255, 255, 0.35)'"
                                >
                                    Bekijk matches
                                </router-link>
                            </div>

                            <div class="control-bar-bottom">
                                <router-link
                                    :to="{ name: 'job-healthcare-view', params: params}"
                                    class="sd-button text-link"
                                    v-ripple="'rgba(255, 255, 255, 0.35)'"
                                >
                                    Bekijk vacature
                                </router-link>

                                <a v-if="!this.closed" class="sd-button edit" @click="editJob" role="button" ><svg-icon icon="pencil"/></a>
                                <a v-if="!this.closed" class="sd-button delete" @click="deleteJob" role="button"><svg-icon icon="trash" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      branch: localStorage.getItem("branch"),
      user: null,
      city: null,
      applicants: null,
      params: {},
      shifts_arr: [],
    };
  },
  props: {
    job: Object,
    job_ids: Array,
    all_jobs: Array,
    apply: Boolean,
    view: Boolean,
    company: Boolean,
    arrow: Boolean,
    match: Boolean,
    recommended: Boolean,
    accept: Boolean,
    applied: Boolean,
    highlight: Boolean,
    closed: Boolean,
    open: Boolean,
  },
  async created() {
    await this.fetchData();
  },
  async mounted() {

  },
  watch: {
    $route: "fetchData",
    job: {
      immediate: true,
      deep: true,
      handler() {
        this.user = JSON.parse(localStorage.getItem("user"));

        if (this.job.job_id) {
          this.params["id"] = this.job.job_id;
        }

        if (this.job.id) {
          this.params["id"] = this.job.id;
        }

        if (this.job_ids) {
          this.params["job_ids"] = this.job_ids;
        }

        if (this.all_jobs && this.all_jobs.length > 1) {
          this.params["job_ids"] = this.all_jobs.map(({ job_id }) => job_id);
        }

        if (this.recommended) {
          this.params["action"] = "apply";
          this.params["matched_job_id"] = parseInt(this.params["id"]);
        } else if (this.match) {
          this.params["action"] = "apply";
        } else if (this.accept) {
          this.params["action"] = "accept";
          this.params["matched_applicant_id"] = parseInt(
            this.job.matched_applicant_id
          );
        } else if (this.applied) {
          this.params["action"] = "applied";
          if(this.job.is_declined) {
            this.params["action"] = "declined";
          }
        } else if (this.closed) {
          this.params["action"] = "closed";
        } else if (this.arrow) {
          this.params["action"] = "view";
        } else if (!this.params["action"]) {
          this.params["action"] = "view";
        }
      }
    }
  },
  methods: {
    getFirstWorkingDate() {
        return new Date(this.job.start_date).toLocaleDateString();
    },
    getLastWorkingDate() {
        return new Date(this.job.end_date).toLocaleDateString();
    },
    async fetchData() {
        // this.shifts_arr = this.job.healthcare_availability.split(", ");
        const raw = this.job.healthcare_availability;
        if (!raw) return ['Nog niet ingevuld'];

        let parsed;
        try {
            parsed = JSON.parse(raw);
        } catch {
            return ['Nog niet ingevuld'];
        }

        const labelMap = {
            day: 'Dag',
            evening: 'Avond',
            night: 'Nacht',
            weekend: 'Weekend',
            hasTransport: 'De zorgmedewerker heeft eigen vervoer nodig'
        };

        this.shifts_arr = Object.keys(parsed)
            .filter(key => parsed[key] === true)
            .map(key => labelMap[key])

        const hasTransport = this.shifts_arr.indexOf('De zorgmedewerker heeft eigen vervoer nodig');
        if (hasTransport !== -1) {
            this.shifts_arr.splice(hasTransport, 1);
            this.shifts_arr.push('De zorgmedewerker heeft eigen vervoer nodig');
        }
    },
    async editJob() {
      localStorage.setItem("job", JSON.stringify(this.job));
      await this.$router.replace({name: "job_step-1-healthcare"});
    },
    async deleteJob() {
      const ID = parseInt(this.job.job_id);
      await this.deleteRecord("/job/" + ID);
      await this.$router.replace({name: "company-dashboard"});
    },
    async onAccept(id) {
      this.$store.state.loading = true;
      await this.acceptJob(id);
      window.scrollTo(0, 0);
      this.$emit("input", "accepted");
    }
  }
};
</script>

<style scoped>

.card .card-top-row {
  display: grid;
  grid-auto-flow: column;
  position: absolute;
  top: -15px;
  width: 100%
}

.card.declined {
  filter: grayscale(1);
}

.card.declined .card-top-row .declined {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 0;
  font-weight: 400;
  height: 25px;
  width: 85px;
  background-color: #F6F6F6;
}

.card .card-top-row .match_percentage {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  font-weight: normal;
  height: 25px;
  width: 85px;
  border-radius: 10px;
  font-size: 12px;
  color: #64513d;
  background-color: #FFCD00;
  margin-left: 15px;
}

.card .card-top-row .bell {
  margin-right: 15px;
  justify-self: flex-end;
  background-color: #FFF;
}

.margin-bottom-2 {
  margin-bottom: 2rem;
}

.job-link .card {
  border: 2px solid #f6f6f6;
  border-radius: 10px;
}

.job-link .card-body {
  padding: 25px;
}

.job-link .card-body-inner {
  display: flex;
}

.jobCardSpecs-image {
  position: relative;
  height: 85px;
  min-width: 85px;
  border-radius: 100px;
  border: 2px solid #f6f6f6;
  background-size: cover;
  background-position: center center;
  margin-right: 18px;
  overflow: hidden;
}

.jobCardSpecs-image .img-item {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
    background-color: #f6f6f6;
}

.jobCardSpecs-image .img-item /deep/svg {
  width: 100%;
  height: 100%;
  padding: 15px;
}

.jobCardSpecs a {
  color: #64513d;
}

.jobCardSpecs ul {
  font-size: 12px;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.jobCardSpecs ul li {
  display: flex;
  align-items: center;
}

.jobCardSpecs ul .shift-items {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    flex-wrap: wrap;
    gap: 10px;
}

.jobCardSpecs ul .shift-items .shift-item {
    background-color: #f6f6f6;
    padding: 7px;
    color: black;
    line-height: 1;
    border-radius: 10px;
}

.jobCardSpecs ul li:not(:last-child) {
  margin-bottom: 10px;
}

/deep/ .jobCardSpecs ul li svg {
  color: #ffcd00;
  width: 15px;
  max-height: 15px;
  margin-right: 6px;
}

.job-link .card .control-bar-top {
  display: flex;
  align-items: center;
}

.job-link .card .control-bar-bottom {
    display: flex;
    flex-direction: row !important;
    gap: 10px;
}

.job-link .card .control-bar-top {
  margin-bottom: 10px;
}

.job-link .card .control-bar-top .sd-button {
  width: 100%;
}

.job-link .card .control-bar .sd-button:not(:last-child) {
  margin-right: 10px;
}

.job-link .card .control-bar-bottom .sd-button {
  background-color: #F6F6F6;
  font-weight: 400;
  color: #64513D;
  width: 100%;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
}

.job-link .card .control-bar .sd-button.delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ff0a0a;
  background-color: rgba(255, 0, 0, 0.2);
  min-width: 35px;
  height: 35px;
  border-radius: 100%;
  width: unset;
}

/deep/.job-link .card .control-bar .sd-button.delete svg {
  height: 15px;
  width: 15px;
}

.job-link .card .control-bar .sd-button.edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 35px;
  height: 35px;
  border-radius: 100%;
  width: unset;
}

/deep/.job-link .card .control-bar .sd-button.edit svg {
  height: 15px;
  width: 15px;
}

.job-link .card .people-overview {
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 10px;
}

.job-link .card .people-overview:not(:last-child) {
  margin-bottom: 10px;
}

.job-link .card .people-overview .profile-circle {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  background-color: #F6F6F6;
  color: #64513D;
  font-size: 12px;
}

@media screen and (max-width: 500px) {
  .job-link .card .control-bar-top,
  .job-link .card .control-bar-bottom {
    flex-direction: column;
  }

  .job-link .card .control-bar-top {
    margin-right: 0;
  }

  .job-link .card .control-bar .sd-button:not(:last-child) {
    margin-right: 0;
    margin-bottom: 10px;
  }

}

</style>